<template>
  <div class="media-advertiser-stat-page">
    <layout>
      <template v-slot:search>
        <div class="search-wrapper">
          <div class="title" style="height:10px;line-height:10px"><a-icon type="search" /> 数据筛选</div>
          <a-space style="margin-top:15px">
            <a-popover v-if="activeTab !== 'worker'" title="广告主ID">
              <template slot="content">
                <a-textarea v-model="advertiser_ids" placeholder="请输入广告主ID" :auto-size="{ minRows: 5, maxRows: 8 }" />
              </template>
              <a-input allow-clear placeholder="广告主ID" v-model="queryParam.advertiser_id" @change="changeOutId"/>
            </a-popover>
            <a-input v-if="activeTab !== 'worker'" allow-clear placeholder="广告主名称" v-model="queryParam.advertiser_name" />
            <a-input v-if="activeTab === 'campaign' || activeTab === 'campaign_list'" allow-clear placeholder="计划ID" v-model="queryParam.campaign_id" />
            <a-input v-if="activeTab === 'campaign' || activeTab === 'campaign_list'" allow-clear placeholder="计划名称，开始包含查询" v-model="queryParam.campaign_name" />
            <a-select allow-clear placeholder="优化师" mode="multiple" v-model="queryParam.worker_id" show-search option-filter-prop="children">
              <a-select-option :value="worker.id" v-for="worker in workers" :key="worker.id">
                {{ worker.name }}
              </a-select-option>
            </a-select>
            <a-select allow-clear placeholder="业务类型" v-model="queryParam.business_type" show-search option-filter-prop="children">
              <a-select-option :value="item.id" v-for="item in businessTypes" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
            <a-select allow-clear placeholder="付费类型" v-model="queryParam.pay_type" show-search option-filter-prop="children">
              <a-select-option :value="item.id" v-for="item in payTypes" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
            <a-select v-if="activeTab === 'campaign_list'" allow-clear placeholder="计划状态" v-model="queryParam.put_status" show-search option-filter-prop="children">
              <a-select-option :value="Number(key)" v-for="(name, key) in putStatusMap" :key="key">
                {{ name }}
              </a-select-option>
            </a-select>

            <span style="margin-right:4px; white-space:nowrap;">报表统计时间</span>
            <a-range-picker :allowClear="false" :default-value="defaultDate" :placeholder="['报表开始日期', '报表结束日期']" v-model="dateRange" valueFormat="YYYY-MM-DD"/>
            <template v-if="activeTab === 'campaign_list'">
              <span style="margin-right:4px; white-space:nowrap;">计划创建时间</span>
              <a-range-picker
                :allowClear="false"
                :default-value="defaultCampaignCreatedDate"
                :placeholder="['计划创建开始', '计划创建结束']"
                v-model="queryParam.campaign_created_date"
                valueFormat="YYYY-MM-DD"
                style="width: 260px"
              />
            </template>
            <a-button type="primary" @click="search">查询</a-button>
            <a-button @click="reset">重置</a-button>
          </a-space>
        </div>
      </template>

      <template v-slot:content>
        <!-- <a-alert
          v-if="activeTab === 'campaign_list'"
          type="info"
          show-icon
          :message="recentCampaignNotice || '当前展示近一个月创建的广告计划，报表数据按所选日期范围合并；无报表数据的计划指标按 0 展示。'"
          style="margin-bottom: 10px"
        /> -->
        <vxe-grid
          ref="tableRef"
          v-bind="tableGrid"
          @page-change="onPageChange"
          @sort-change="handleSortChange"
          @checkbox-change="handleSelect"
          @checkbox-all="handleSelect"
          :column-config="{ useKey: true }"
          :row-config="{ useKey: true }"
        >
          <template #toolbar_buttons>
            <a-tag v-if="activeTab !== 'campaign_list'" color="cyan" > 花费(元)： {{ sum_cost }} </a-tag>
            <a-button
              v-if="activeTab === 'advertiser' && accessTo('advertiserEnableAllCampaigns')"
              type="primary"
              :loading="advertiserEnableLoading"
              @click="batchEnableAdvertiserCampaigns"
              style="margin-left: 10px"
            >
              批量开启广告主计划
            </a-button>
            <a-button
              v-if="activeTab === 'advertiser' && accessTo('advertiserCloseAllCampaigns')"
              type="danger"
              :loading="advertiserCloseLoading"
              @click="batchCloseAdvertiserCampaigns"
              style="margin-left: 10px"
            >
              批量关停广告主计划
            </a-button>
            <a-button
              v-if="activeTab === 'campaign' || activeTab === 'campaign_list'"
              type="primary"
              :loading="enableLoading"
              @click="batchEnableCampaigns"
              style="margin-left: 10px"
            >
              批量启用
            </a-button>
            <a-button
              v-if="activeTab === 'campaign' || activeTab === 'campaign_list'"
              type="danger"
              :loading="closeLoading"
              @click="batchCloseCampaigns"
              style="margin-left: 10px"
            >
              批量关停
            </a-button>
            <a-tabs v-model="activeTab" @change="onTabChange">
              <a-tab-pane key="worker" tab="优化师报表" />
              <a-tab-pane key="advertiser" tab="广告主报表" />
              <a-tab-pane key="campaign" tab="广告计划报表" />
              <a-tab-pane key="campaign_list" tab="广告计划" />
            </a-tabs>
          </template>
          <template #put_status_default="{ row }">
            <a-tag :color="putStatusColor[row.put_status] || 'default'">
              {{ putStatusMap[row.put_status] || '未知' }}
            </a-tag>
          </template>
          <template #actions="{ row }">
            <a
              v-if="row.put_status === 1"
              class="close-action"
              @click="closeSingleCampaign(row)"
            >关停</a>
            <a
              v-else-if="row.put_status === 2"
              class="enable-action"
              @click="enableSingleCampaign(row)"
            >启用</a>
            <a-tag
              v-else-if="row.put_status === 4"
              color="blue"
            >执行中</a-tag>
            <span v-else class="disabled-action">-</span>
          </template>
          <template #advertiser_actions="{ row }">
            <a
              v-if="activeTab === 'advertiser' && accessTo('advertiserEnableAllCampaigns')"
              class="enable-action"
              @click="enableAllAdvertiserCampaignsForRow(row)"
            >开启全部</a>
            <a-divider type="vertical" />
            <a
              v-if="activeTab === 'advertiser' && accessTo('advertiserCloseAllCampaigns')"
              class="close-action"
              @click="closeAllAdvertiserCampaignsForRow(row)"
            >关停全部</a>
          </template>
          <!-- 表头悬浮描述：鼠标放到带 question-circle 的表头时展示字段口径说明 -->
          <template #tooltip_header="{ column }">
            <a-tooltip>
              <template slot="title">
                <span v-if="column.field === 'minigame_iaa_purchase_amount_three_day_by_conversion_roi'">激活后三日广告变现ROI：所选时间范围内的激活用户在激活后三日内的变现ROI，计算公式：激活后三日广告LTV / 消耗</span>
                <span v-else-if="column.field === 'minigame_iaa_purchase_amount_week_by_conversion_roi'">激活后七日广告变现ROI：所选时间范围内的激活用户在激活后七日内的变现ROI，计算公式：激活后七日广告LTV / 消耗</span>
                <span v-else-if="column.field === 'minigame_iaa_purchase_amount_15_day_by_conversion_roi'">激活后15日广告变现ROI：所选时间范围内的激活用户在激活后15日内的变现ROI，计算公式：激活后15日广告LTV / 消耗</span>
                <span v-else-if="column.field === 'minigame_iaa_purchase_amount_30_day_by_conversion_roi'">激活后30日广告变现ROI：所选时间范围内的激活用户在激活后30日内的变现ROI，计算公式：激活后30日广告LTV / 消耗</span>
                <span v-else-if="column.field === 'event_pay_purchase_amount_three_day_by_conversion_roi'">激活后3日ROI：激活后3日付费金额 / 当日消耗</span>
                <span v-else-if="column.field === 'event_pay_purchase_amount_week_by_conversion_roi'">激活后7日ROI：激活后7日付费金额 / 当日消耗</span>
                <span v-else-if="column.field === 'event_pay_purchase_amount_15_day_by_conversion_roi'">激活后15日ROI：激活后15日付费金额 / 当日消耗</span>
                <span v-else-if="column.field === 'event_pay_purchase_amount_30_day_by_conversion_roi'">激活后30日ROI：激活后30日付费金额 / 当日消耗</span>
              </template>
              {{ column.title }}
              <a-icon type="question-circle" style="font-size: 12px; color: #999;" />
            </a-tooltip>
          </template>
        </vxe-grid>
      </template>
    </layout>
  </div>
</template>

<style lang="less" scoped>
@import 'MediaAdvertiserStat';
</style>

<script>
import MediaAdvertiserStat from './MediaAdvertiserStat'
export default MediaAdvertiserStat
</script>
